<template>
    <div class="md cart-null">
        <img :src="cartImage">
        <span>{{ $t('popup.shoppingcart.item.empty') }}</span>
    </div>
</template>

<script>
    export default {
        data: function(){
            
            return {}
        },
        computed: {
            cartImage: function(){
                return process.env.BASE_URL +'images/emptyCart.svg';
            }
        },
    }
</script>

<style scoped lang="scss">

    .md.cart-null {
        margin: 0 auto;

        &.is-cartList {
            margin-top: 15vh;

            img {
                max-width: 600px;
            }
        }

        img {
            display: block;
            width: auto;
            max-width: 300px;
        }

        span {
            display: block;
            font-size: $font-size-xl;
            text-align: center;
            color: $major-color;
            margin-top: $interval-m;
        }
    }
</style>
